var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftback(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_89",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_89",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAAB5klEQVR4nO3cPY4TQRRF4VNjBKhFjBB7IYEMicnZgAMiltBiBUQESMTkkJBAMntxQIwsgjFNAA0DCGzGY9d7VefLLZXusdp/coMkSZIkSZIkSZIkSZKkf1mOq2E5roba5/gfJ7UPcFWW42o4Z/Fmw+Ldk/Hjrdrn2VWpfYCrMI/PxAOAUji7QXn4Yrz9qfbZtkkf4PfxZ1kipA7wt/FnGSKkDbBt/Fn0CClfhJfjajifFm+3jQ8wTdz7PPH6GOe6jHQBfjzz4f6OD1mX6cvzQ55pH6kuQbtedi5Yl2k6ffXszvuDHmwPaQK0OD4kCdDq+JAgQMvjQ/AArY8PgQP0MD4EDdDL+BAwQE/jQ7AAvY0PgQL0OD4ECdDr+BAgQM/jQ+UAvY8PFQM4/jdVAjj+T0cP4Pi/OmoAx/9Tul/EWuMlqDJfhCvzbWhlfhCrzK8iKqseAPqOECIA9BshTADoM0KoANBfhHABoK8IIQNAPxHCBoA+IoQOAO1HCB8A2o6QIgC0GyFNAGgzQqoA0F6EdL+IvRzvrq+xOQU+7PiQYSonTw95pn2kCwDfI5TNIwpbn9WlcHaz8PgY57qMdJegi/yjdgDeqiAAb9YRwByhwPUs4zcn4w2bJEmSJEmSJEmSJEmSpAP4CiXnvb2qrpnhAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftback);
export default __webpack_public_path__ + "static/media/leftback.a03042256d4d908708a8efbd414a023b.svg";
export { ForwardRef as ReactComponent };